/**
 * Seeq REST API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 66.221.0-v202611031945-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

/**
 * A filter for filtering a single column against a given value
 */
export interface ValueFilter {
    /**
     * The name of the column to filter against. If filtering against context, prepend the name with either 'context_comment.', 'context_label.', or 'context_opaque.'. For example, you can filter for rows with comments updated after a certain date by filtering against 'context_comment.updated_at'
     */
    "columnName"?: string;
    /**
     * Specifies where the filter should be applied: ROW (WHERE clause, filters individual rows before grouping) or AGGREGATED (participates in grouping context). Defaults to ROW for backward compatibility.
     */
    "filterTarget"?: FilterTargetEnum;
    /**
     * The grouping column ID this filter targets (e.g., 'item id' for condition-level, 'Asset' for asset-level). When set on an AGGREGATED filter, the backend uses HAVING if it matches the current grouping column, or a WHERE scalar subquery otherwise.
     */
    "filterTargetColumn"?: string;
    /**
     * The operation to use in combination with the value
     */
    "filterType"?: FilterTypeEnum;
    "value"?: models.Value;
}

export const FilterTargetEnum = {
    ROW: 'ROW',
    AGGREGATED: 'AGGREGATED'
} as const;

export type FilterTargetEnum = typeof FilterTargetEnum[keyof typeof FilterTargetEnum];
export const FilterTypeEnum = {
    LESSTHAN: 'LESS_THAN',
    LESSTHANOREQUAL: 'LESS_THAN_OR_EQUAL',
    GREATERTHAN: 'GREATER_THAN',
    GREATERTHANOREQUAL: 'GREATER_THAN_OR_EQUAL',
    IN: 'IN',
    NOTIN: 'NOT_IN',
    EQUALS: 'EQUALS',
    EQUALSIGNORECASE: 'EQUALS_IGNORE_CASE',
    NOTEQUALS: 'NOT_EQUALS',
    CONTAINS: 'CONTAINS',
    NOTCONTAINS: 'NOT_CONTAINS',
    REGEXMATCHES: 'REGEX_MATCHES',
    NOTREGEXMATCHES: 'NOT_REGEX_MATCHES',
    BEGINSWITH: 'BEGINS_WITH',
    ENDSWITH: 'ENDS_WITH',
    DELIMITEDFIELDCONTAINS: 'DELIMITED_FIELD_CONTAINS'
} as const;

export type FilterTypeEnum = typeof FilterTypeEnum[keyof typeof FilterTypeEnum];
